import { Card } from '../ui/Card';
import { fmt, fmtInt } from '../../lib/format';
import type { CalculatorResults, CalculatorInputs } from '../../lib/types';

interface Props {
  inputs: CalculatorInputs;
  results: CalculatorResults;
}

export function LoanStatsCard({ inputs, results }: Props) {
  const { loanAmount, ltv, totalInterest, totalPIPaid, interestToPrincipalRatio, monthlyPI } = results;

  return (
    <Card title="Loan Summary">
      <div className="stat-grid">
        <div className="stat-box">
          <div className="stat-value">${fmtInt(loanAmount)}</div>
          <div className="stat-label">Loan Amount</div>
        </div>
        <div className="stat-box">
          <div className="stat-value">{ltv.toFixed(1)}%</div>
          <div className="stat-label">Loan-to-Value</div>
        </div>
        <div className="stat-box">
          <div className="stat-value">${fmtInt(totalInterest)}</div>
          <div className="stat-label">Total Interest ({inputs.loanTerm}yr)</div>
        </div>
        <div className="stat-box">
          <div className="stat-value">${fmtInt(totalPIPaid)}</div>
          <div className="stat-label">Total P&I Paid</div>
        </div>
        <div className="stat-box">
          <div className="stat-value">{interestToPrincipalRatio.toFixed(1)}%</div>
          <div className="stat-label">Interest / Principal</div>
        </div>
        <div className="stat-box">
          <div className="stat-value">${fmtInt(monthlyPI)}</div>
          <div className="stat-label">P&I Only</div>
        </div>
      </div>
    </Card>
  );
}
